define('notifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('notifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"notifications\"><div data-view=\"Order.Notifications\"></div><div data-view=\"Profile.Notifications\"></div></div>";
},"useData":true}, 'extensions/MHI/DHI/3.3.0/', 'extensions/MHI/DHI/3.3.0/', Handlebars);
});